import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import GenericListTab from "./../../factories/generic-list-tab";
class TeamCalendarShiftbook extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() {
        return "Shiftbook";
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    SearchConfig: Models.BaoSearchDialogConfig = {
        SearchType: this.SearchType(),
        AutoSearch: true,
        MultiSelect: false,
        ObjectId: ko.observable<string>(),
        ObjectValue: "PrimaryKeyValue",
        CustomFilter: { SessionTabId: this.SessionTabId, OnlyDisplayableInTeamCalendar: true },
        ApplyItemCallback: (searchVM) => {
            this.SaveSearchItem(searchVM.SelectedItem());
        }
    };
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default TeamCalendarShiftbook;